export default __webpack_public_path__ + "static/media/chase-cards.c7f543ca.png";